import React, {useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {RootState} from "../../../reducers";
import {useCart} from "../../services/Cart/cartService";
import {getCart} from "../../services/Cart/reducer";
import {ReactComponent as RemoveSVG} from "../../../images/icons/remove.svg";
import {ReactComponent as PlusSVG} from "../../../images/icons/plus.svg";
import {ReactComponent as CashbackOutlineSVG} from "../../../images/icons/cashback-outline.svg";
import {getUser} from "../../services/User/reducer";
import Money from "../Common/Money";

interface OwnProps {
    errors: any[],
    updateErrors: (errors: any) => void,
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const CartCashbackComponent = (props: Props) => {
    const {t} = useTranslation();
    const cart = props.cart;
    const [loading, setLoading] = useState(false);
    const cartService = useCart();
    const cashbackPromotion = cart.promotions.filter(x => x.type === "CREDIT")[0];
    const usedCashback = !!cashbackPromotion;
    let restCashback = props.user.promotional_credits || 0;

    if (cashbackPromotion && cashbackPromotion.value_money) {
        restCashback = restCashback - cashbackPromotion.value_money.amount;
    }

    if (!props.user.promotional_credits) {
        return null;
    }

    const removeCashback = async () => {
        if (!cashbackPromotion) return;
        setLoading(true)
        try {
            await cartService.removePromotion(cashbackPromotion.id);
            setLoading(false)
        } catch (error: any) {
            setLoading(false)
        }
    }

    const addCashback = async () => {
        setLoading(true)
        try {
            await cartService.refreshUser();
            setLoading(false)
        } catch (error: any) {
            setLoading(false)
        }
    }

    const useCashback = async () => {
        if (usedCashback) {
            await removeCashback();
        } else {
            await addCashback()
        }
    }

    return (
        <div className={"btn btn-default btn-nav btn-lg mb-3 cashback-btn"}>
            <CashbackOutlineSVG className={"text-success"}/>
            <span>
                {cashbackPromotion ? (
                    <>
                        <span>
                            <span className="text-success">
                                <Money value={cashbackPromotion.value_money}/>
                            </span>
                            <span className="ms-1">{t("modules.cart.field.rest_of_cashback.title")}</span>
                        </span>
                        <small className="text-muted">
                            {`${t("modules.cart.field.amount_remain_on_account.title")}: `}
                            <Money value={restCashback}/>
                        </small>
                    </>
                ) : (
                    <>
                        {`${t("modules.cart.field.on_account.title")}: `}
                        <Money value={restCashback}/>
                    </>
                )}
            </span>
            {usedCashback ? (
                <button className={`btn btn-outline-danger btn-icon btn-spinner${loading ? " loading" : ""}`}
                        disabled={loading}
                        onClick={useCashback}>
                    <span className="left spinner-border spinner-border-sm"/>
                    <RemoveSVG/>
                </button>
            ) : (
                <button className={`btn btn-outline-success btn-icon btn-spinner${loading ? " loading" : ""}`}
                        disabled={loading}
                        onClick={useCashback}>
                    <span className="left spinner-border spinner-border-sm"></span>
                    <PlusSVG/>
                </button>
            )}
        </div>
    )
}


const mapStateToProps = (state: RootState) => ({
    cart: getCart(state.cart),
    user:
        getUser(state.user),
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(CartCashbackComponent));